import { put, takeLatest } from 'redux-saga/effects';
import httpClient from '../../../utils/http-client';
import { fetchReportTemplateFail, fetchReportTemplateSuccess } from '../actions';
import ReportTemplateActionTypes from '../types';

export function* fetchReportTemplates({ payload }) {
  try {
    const response = yield httpClient.get('/report-templates', {
      params: payload,
    });
    yield put(fetchReportTemplateSuccess(response?.data));
  } catch (error) {
    yield put(fetchReportTemplateFail(error?.message));
  }
}

export function* onFetchReportTemplatesStart() {
  //@ts-ignore
  yield takeLatest(ReportTemplateActionTypes.FETCH_REPORT_TEMPLATE_START, fetchReportTemplates);
}
